import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@trdk/style/Button';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';

const NotFound = () => {
  const classes = useStyles();
  const history = useHistory();
  return (
    <>
      <Typography variant="h1" className={classes.header}>
        Side ikke funnet
      </Typography>
      <Button color="primary" variant="outlined" onClick={() => history.push('/')}>
        Gå tilbake til startsiden
      </Button>
    </>
  );
};

const useStyles = makeStyles({
  header: {
    fontSize: '2.2rem',
    padding: '1rem 0',
  },
});

export default NotFound;
